import { sum }                  from '../../../util';
import { Charting }             from '../../../types/charting';
import { useChartReportExport } from './useChartReportExport';

type ReportChartingType = Charting.Reports.BudgetCategoryDataByBusinessFunctionYearly.ChartingType;
type ReportChartingData = Charting.Reports.BudgetCategoryDataByBusinessFunctionYearly.ChartingData;

type HookType = Charting.Reporting.ChartReportExportHookMethod<ReportChartingType, ReportChartingData>;
type HookOptions = Charting.Reporting.ChartReportExportHookOptions<ReportChartingType>;

export const useBudgetCategoryDataByBusinessFunctionYearlyChartReportExport: HookType = ( options: HookOptions ) => {
	
	const defaultHandlers = useChartReportExport( options );
	
	/* Generate text/ string */
	const generateReportText: ReturnType<HookType>['generateReportText'] = ( data ) => {
		
		const text = data.datasets.map( ( dataset ) => {
			
			const businessFunction = dataset.label,
			      total            = options.datapointFormatter( sum( dataset.data ) ),
			      years            = dataset.data.map( ( yearTotal, index ) => `- ${ data.labels[ index ] }: ${ options.datapointFormatter( yearTotal ) }` );
			
			return [ businessFunction, ...years, `- Total: ${ total }` ].join( '\n' );
		} );
		
		return text.join( '\n\n' );
	}
	
	/* Generate CSV Headers + Data */
	const generateCSVData: ReturnType<HookType>['generateCSVData'] = ( data ) => {
		
		// [ Business Function, ...Year Columns, Total ]
		let csvHeaders = [
			
			{ label: "Business Function", key: "Business Function" },
			
			...data.labels.map( label => ( {
				label: label,
				key:   `${ label }`
			} ) ),
			
			{ label: "Total", key: "Total" },
		];
		
		let csvData = data.datasets.map( dataset => {
			
			const csvRow = {
				'Business Function': dataset.label,
				'Total':             options.datapointFormatter( sum( dataset.data ) ),
			}
			
			dataset.data.map( ( datapointValue, index ) => {
				csvRow[ `${ data.labels[ index ] }` ] = options.datapointFormatter( datapointValue );
			} );
			
			return csvRow;
		} );
		
		return {
			headers:  csvHeaders,
			data:     csvData,
			filename: `Report - ${ options.title }.csv`,
			target:   '_blank',
		}
	}
	
	return {
		generateReportText,
		generateCSVData,
		handleCopiedtoClipboard: defaultHandlers.handleCopiedtoClipboard,
		handleCSVGenerated:      defaultHandlers.handleCSVGenerated,
		handleSaveAsImage:       defaultHandlers.handleSaveAsImage,
	};
};
